export enum TipoVivienda
{
    PropiaConDeuda = 'Propia con Deuda',
    PropiaSinDeuda = 'Propia sin Deuda',
    Arrendada = 'Arrendada',
    ViveConFamiliares = 'Vive con Familiares',
    DelConyuge = 'Del Cónyuge',
    Fiscal = 'Fiscal',
    Otro = 'Otro'
}